import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosSharedModule } from '../shared/module'
import { IcosDialog } from './dialog'

export function getDocument(): any { return document }
export function getWindow(): any { return window }
@NgModule({
  declarations: [IcosDialog],
  exports: [IcosDialog],
  imports: [CommonModule, IcosSharedModule],
  entryComponents: [IcosDialog],
})
export class IcosDialogModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosDialogModule, providers: [] }
  }
}
